import React, { FC, useEffect } from 'react';
import cls from './styles.module.scss';
import { GraphBackButton } from './shared/GraphBackButton/GraphBackButton';
import { GraphNameInput } from './shared/GraphNameInput/GraphNameInput';
import { GraphExportButton } from './shared/GraphExportButton/GraphExportButton';
import { GraphSaveStatus } from './shared/GraphSaveStatus/GraphSaveStatus';
import { useCurrencyListStore, useGraphStatusStore } from '../../libs/store';
import { GraphInput } from '@graph/ui/GraphToolbar/shared/GraphInput/GraphInput';
import { GraphLoader } from '@graph/ui/GraphStatus/shared/GraphLoader/GraphLoader';
import { useConvertHtmlToImagePng } from '@rubin-dev/octavius';
import { TokenSelect } from '@graph-sidebar-module/features/Token';
import { GraphSidebarButton } from '@graph/ui/GraphToolbar/shared/GraphSidebarButton/GraphSidebarButton';
import { useSidebarWindow } from '@graph-sidebar-module/shared';
import { Network } from '@apolloGenerated';
import { getNetworkEnum } from '@helpers/address';

export const GraphToolbar: FC<{ network: Network }> = ({ network }) => {
  const { isInitialized } = useGraphStatusStore();
  const { graphCurrentCurrency, onGraphChangeCurrency } = useCurrencyListStore();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, { isShow }] = useSidebarWindow();

  // @ts-ignore пофиксить типы в либе
  const [createImage, loading] = useConvertHtmlToImagePng({});

  useEffect(() => {
    if (getNetworkEnum(network) === Network.Btc) {
      onGraphChangeCurrency(Network.Btc);
    }
  }, [network]);

  if (loading) {
    return <GraphLoader background={'rgba(0,0,0,0.8)'} />;
  }

  return (
    <div className={cls.graphToolbar}>
      <div className={cls.graphToolbar__container}>
        {isInitialized && (
          <>
            <div className={cls.graphToolbar__wrapper}>
              <GraphSaveStatus className={cls.graphToolbar__saveLoader} />
              <div className={cls.graphToolbar__group}>
                <GraphBackButton />
                <GraphNameInput
                  appendSlot={
                    <GraphExportButton
                      //@ts-ignore доработать типы в либе
                      createImage={createImage}
                    />
                  }
                />
              </div>
              <GraphInput />
            </div>
            <div className={cls.graphToolbar__select}>
              <TokenSelect
                hasUsd
                size="large"
                fullWidth={isShow}
                onChange={onGraphChangeCurrency}
                currentNetwork={graphCurrentCurrency}
                network={network}
              />
            </div>
          </>
        )}
      </div>
      {!isShow && <GraphSidebarButton />}
    </div>
  );
};
